const Media = [
    {
        "id" : "linkedin",
        "Title": "LinkedIn",
        "link": "https://www.linkedin.com/in/debasish-mohanty-634b91204/",
        "img": "./assets/images/contact_logos/linked_in_logo.png",
    },
    {
        "id" : "github",
        "Title": "GitHub",
        "link": "https://github.com/TRY-ER",
        "img": "./assets/images/contact_logos/github_logo.webp",
    }
]

export { Media }